import * as React from "react";
import { IconNames } from "core/models";
import { Tooltip, Icon } from "ui/components";
import { cx } from "utils/join-classnames";
import styles from "./Switch.module.scss";

type SwitchOptions = {
    icon: IconNames;
    tooltip: string;
    value: "crop" | "resize";
    extraOption?: boolean;
};
type Props = {
    options: SwitchOptions[];
    activeOption: string;
    handleChange?: (value: "crop" | "resize") => void;
    textOnly?: boolean;
    disabled?: boolean;
};

const Switch: React.FC<Props> = ({
    options,
    activeOption,
    handleChange,
    textOnly = false,
    disabled = false,
}) => (
    <div
        className={cx(styles.switch, textOnly ? styles.switch__textonly : null)}
    >
        {options.map((option) => {
            const containerClasses = [];
            containerClasses.push(styles.switch__option);
            if (activeOption === option.value) {
                containerClasses.push(styles.switch__option__active);
            }
            if (disabled) {
                containerClasses.push(styles.switch__option__disabled);
            }
            let optionContent = (
                <Tooltip
                    text={option.tooltip}
                    className={styles.switch__option__tooltip}
                >
                    <Icon name={option.icon} />
                </Tooltip>
            );
            if (textOnly) {
                optionContent = <span>{option.tooltip}</span>;
            }

            return (
                <div
                    className={containerClasses.join(" ")}
                    key={option.value}
                    onClick={() => {
                        if (!disabled) {
                            if (handleChange) {
                                handleChange(option.value);
                            }
                        }
                    }}
                    role="presentation"
                >
                    {optionContent}
                </div>
            );
        })}
    </div>
);

export default Switch;
